module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elinor Klivans, Susie Cushner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elinor Klivans is the best-selling author of many cookbooks, including "), _c('I', [_vm._v("Cupcakes")]), _vm._v(" and "), _c('I', [_vm._v("Chocolate Cakes")]), _vm._v(". She lives in Camden, Maine."), _c('br'), _c('br'), _vm._v("Susie Cushner is a food and travel photographer living in New York.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7zj400/tc-custom/9781452100166.jpg?1718106413325",
      "alt": "This image is the cover for the book Fast Breads"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fast Breads\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The master baker is back with the finest no-fuss recipes for homemade breads of all kinds—from crusty artisanal bread to biscuits, babka and more!")]), _c('br'), _c('br'), _vm._v("Best-selling author and baking authority Elinor Klivans presents sixty-five quick and simple recipes for irresistibly delicious homemade breads. With her easy-to-master techniques, anyone can whip up such delightful treats as Apricot Corn Muffins, Anytime Butter Twists, and Buttermilk Corn Bread, plus really super-fast favorites like Pumpkin Chocolate Chip Pancakes and Very Big Popovers, all with a minimum of sweat in the kitchen. "), _c('br'), _c('br'), _vm._v("From morning treats like crumpets, muffins, and sticky breads to savory and nutritious multigrains and dark ryes, "), _c('i', [_vm._v("Fast Breads")]), _vm._v(" will make any novice baker into a master bread maker!\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0